module.exports = __webpack_public_path__ + "static/media/modern-architecture-twin-building.7eb2c17b.svg";